import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Feed from "@/pages/Feed";
import StoryDetail from "@/pages/StoryDetail";
import Write from "@/pages/Write";
import FutureSelf from "@/pages/FutureSelf";
import Gratitude from "@/pages/Gratitude";
import Empathy from "@/pages/Empathy";
import EmpathyDetail from "@/pages/EmpathyDetail";
import Directory from "@/pages/Directory";
import TherapistDetail from "@/pages/TherapistDetail";
import ApplyAsCounselor from "@/pages/ApplyAsCounselor";
import Founder from "@/pages/Founder";
import TherapistPortal from "@/pages/TherapistPortal";
import CounselorLogin from "@/pages/CounselorLogin";
import AdminApplications from "@/pages/AdminApplications";
import AdminDashboard from "@/pages/AdminDashboard";
import Dashboard from "@/pages/Dashboard";
import MessagesPage from "@/pages/MessagesPage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/feed" element={<Feed />} />
              <Route path="/story/:id" element={<StoryDetail />} />
              <Route path="/write" element={<ProtectedRoute><Write /></ProtectedRoute>} />
              <Route path="/future-self" element={<ProtectedRoute><FutureSelf /></ProtectedRoute>} />
              <Route path="/gratitude" element={<ProtectedRoute><Gratitude /></ProtectedRoute>} />
              <Route path="/empathy" element={<Empathy />} />
              <Route path="/empathy/:id" element={<EmpathyDetail />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/directory/apply" element={<ApplyAsCounselor />} />
              <Route path="/directory/:id" element={<TherapistDetail />} />
              <Route path="/founder" element={<Founder />} />
              <Route path="/therapist" element={<ProtectedRoute><TherapistPortal /></ProtectedRoute>} />
              <Route path="/counselor/login" element={<CounselorLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/applications" element={<ProtectedRoute><AdminApplications /></ProtectedRoute>} />
              <Route path="/messages" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            </Routes>
          </Layout>
          <Toaster richColors position="top-right" offset={80} />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
